// src/index.tsx
import { jsx } from "react/jsx-runtime";
function nl2br(input) {
  if (typeof input === "string") {
    const newlineRegex = /\r\n|\n|\r/g;
    return input.split(newlineRegex).flatMap(
      (part, index, array) => index < array.length - 1 ? [part, /* @__PURE__ */ jsx("br", {}, index)] : [part]
    );
  }
  return input;
}
var src_default = nl2br;
export {
  src_default as default
};
//# sourceMappingURL=index.mjs.map